// array 에서 falsy 한 값들을 제거하는 함수

export const cleanArray = (arr: any[]) => arr.filter(Boolean);
